import { createTheme } from '@material-ui/core/styles';

export const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#3780de',
      light: '#75afff',
      dark: '#0054ac',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#8c8c8c',
      light: '#bcbcbc',
      dark:'#5f5f5f',
      contrastText: '#ffffff',
    },
    text: {
      primary: '#000000',
    },
    background: {
      default: '#e0e0e0',
      paper: '#fafafa',
    },
    type: 'light',
  },
  direction: 'ltr', 
  typography:{
    fontFamily: "'Roboto', sans-serif",
    htmlFontSize: 16,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },props: {
    MuiButton: {
      size: 'small',
    },
    MuiFilledInput: {
      margin: 'dense',
    },
    MuiFormControl: {
      margin: 'none',
    },
    MuiFormHelperText: {
      margin: 'dense',
    },
    MuiIconButton: {
      size: 'small',
    },
    MuiInputBase: {
      margin: 'dense',
    },
    MuiInputLabel: {
      margin: 'dense',
    },
    MuiListItem: {
      dense: true,
    },
    MuiOutlinedInput: {
      margin: 'dense',
    },
    MuiFab: {
      size: 'small',
    },
    MuiTable: {
      size: 'small',
    },
    MuiTextField: {
      margin: 'none',
    },
    MuiToolbar: {
      variant: 'dense',
    },
  },
  overrides: {
    MuiIconButton: {
      sizeSmall: {
        // Adjust spacing to reach minimal touch target hitbox
        marginLeft: 4,
        marginRight: 4,
        padding: 12,
      },
    },
  },
});

export default defaultTheme;